
import { connect } from 'react-redux';

let maybe = (cond, children) => {
    return cond ? children : null;
}

let ProblemsList;
if ( "production" !== process.env.NODE_ENV ) {
    ProblemsList = (props) => {
        return (
            <div className="problems-box">
                <b>Probleme im Datensatz:</b>
                <ul>
                    {props.problems.map( (p, i) => <li key={i}>{p}</li> )}
                </ul>
            </div>
        );
    }
}

function Result(props) {
    let r = props.result;

    let difficulty = r.difficulty && r.difficulty.order ? r.difficulty.order : 1;

    let problems = null;
    if ( "production" !== process.env.NODE_ENV  ) {
        problems = r.problems.length > 0 ? <ProblemsList problems={r.problems} /> : null;
    }

    let sun_map = {
        sso: "sehr sonnig",
        so: "sonnig",
        sosch: "sonnig/schattig",
        sch: "schattig",
        ssch: "sehr schattig",
    }

    let lage_icons = {
        "tal": "https://tramino.s3.amazonaws.com/s/alpininfo/769948/tal.png",
        "mittlerelage": "https://tramino.s3.amazonaws.com/s/alpininfo/769947/mittlerelage.png",
        "alpin": "https://tramino.s3.amazonaws.com/s/alpininfo/769945/alpin.png",
    }


    return (
        <div className="result grid margin">

            <div className="col col-3">
                <img src={r.image} />
            </div>

            <div className="col col-5">
                { r.link
                    ? <h2><a href={r.link}>{r.name}</a></h2>
                    : <h2>{r.name}</h2>
                }
                
                <p>{r.info}</p>

                { /* 
                <p>
                    <b>fitness:</b> {r.fitness ? r.fitness.name : null}<br />
                    <b>difficulty:</b> {r.difficulty ? r.difficulty.name : null}<br />
                    <b>kategorie:</b> {r.kategorie ? r.kategorie.name : null}<br />
                    <b>status:</b> {r.status ? r.status.name : null}<br />
                    <b>jahreszeit:</b> {r.jahreszeit ? r.jahreszeit.name : null}<br />
                </p>
                */ }

                {problems}
            </div>

            <div className="col col-1">
                <span className={props.faved ? "fav faved" : "fav"} onClick={e => props.toggleFav(r.id)}></span>
                <span className="lage-icon"><img src={lage_icons[r.lage.value]} /></span>
                
                {r.kinderwagen ? <span className="kinderwagen-icon"><img src="https://tramino.s3.amazonaws.com/s/alpininfo/769946/kinderwagen.png" /></span> : null}
            </div>

            <div className="col col-3">
                { r.wertung_alpine_erfahrung ? (
                <div className="rating">
                    <div className={"rating_box box1 " + ( r.wertung_alpine_erfahrung >= 0 ? "aktiv" : "" )}>&nbsp;</div>
                    <div className={"rating_box box2 " + ( r.wertung_alpine_erfahrung >= 1 ? "aktiv" : "" )}>&nbsp;</div>
                    <div className={"rating_box box3 " + ( r.wertung_alpine_erfahrung >= 2 ? "aktiv" : "" )}>&nbsp;</div>
                    <div className={"rating_box box4 " + ( r.wertung_alpine_erfahrung >= 3 ? "aktiv" : "" )}>&nbsp;</div>
                    <div className={"rating_box box5 " + ( r.wertung_alpine_erfahrung >= 4 ? "aktiv" : "" )}>&nbsp;</div>
                </div>
                ) : null }

                <div className="infotext">{r.wertung_alpine_erfahrung_value}</div>

                <div className="properties">
                    { r.distance ? <div className="property laenge">{Math.ceil(r.distance / 1000)} km</div> : null }
                    <div className="property hm_up">{r.hm_up} m</div>
                    <div className="property hm_down">{r.hm_down} m</div>
                    <div className="property dauer">{r.time} h</div>
                    { maybe(r.sonnigerweg, 
                        <div className={`property sonnigerweg ${r.sonnigerweg.value}`}>
                            {sun_map[r.sonnigerweg.value]}
                        </div>
                    )}
                        <a href={`https://cdn.tramino.net/temp/pdf/form/389/entry/${r.id}.pdf`} target="_blank" className="pdf-download-button">PDF Datenblatt</a>
                </div>

            </div>

        </div>
    )
}


function ResultList(props) {
    let { results, search, loading, favorites, favoritesOnly } = props;
    let { onChangeSearch, toggleFav, toggleFavoritesOnly } = props;

    if ( favoritesOnly && favorites.length > 0 ) {
        results = results.filter(r => favorites.indexOf(r.id) !== -1);
    }

    return (
        <div className="resultslist">
            <div className="results-header">
                <div className="tab">
                    {
                        !loading ? (
                            !favoritesOnly 
                            ? <span>{results.length} {results.length == 1 ? "Tour" : "Touren"} gefunden</span>
                            : <span>Nur Favoriten angezeigt</span>
                        ) : <span>Suche läuft...</span>
                    }
                </div>
                <div className="tab clickable" onClick={toggleFavoritesOnly}>
                    <span className={favoritesOnly ? "fav faved" : "fav"} />
                    <span>{favorites.length} {favorites.length === 1 ? "Favorit" : "Favoriten"}</span>
                </div>
                {/*
                <div className="tab clickable">
                    <span>Drucken</span>
                </div>
                */}
                <div className="tab right">
                    <input type="text" placeholder="Stichwortsuche" onChange={onChangeSearch} value={search} />
                </div>
            </div>

            {loading ?
            <div className="loading-wrapper">
                <div className="spinner" id="loading">
                    <div className="double-bounce1"></div>
                    <div className="double-bounce2"></div>
                </div>
                Einen Moment bitte...
            </div>
            : (
                <div className="results">
                    { results.map((r, i) => <Result faved={favorites.indexOf(r.id) !== -1} toggleFav={toggleFav} result={r} key={i} />) }
                </div>
            ) }

        </div>
    )
}

let mapStateToProps = (state) => {
    return {
        loading: state.loading,
        favoritesOnly: state.favoritesOnly,
        favorites: state.favorites,
        results: state.filteredEntries,
        search: state.filter.search,
    };
}

import { setFilter, toggleFav, toggleFavoritesOnly } from '../store';


let mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onChangeSearch: (e) => {
            dispatch(setFilter("search", e.currentTarget.value));
        },
        toggleFav: (id) => {
            dispatch(toggleFav(id));
        },
        toggleFavoritesOnly: () => {
            dispatch(toggleFavoritesOnly());
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResultList);




// WEBPACK FOOTER //
// ./components/ResultList.js